import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import React, { Component } from 'react';
// import LayerDevicesContent from '../layerInfo/layers-devices/layer-devices-content';


// class PopUpDeviceInfo extends Component {
//     render() {
//         return (

//             <div id="location-detail-7" className="location-detail-box location-detail-7 panel panel-default">
//                 {
//                     this.props.children[2]
//                 }

//                 {/* <LayerDevicesContent
//                     child={this.props.children}
//                     address={this.props.address}
//                     isOpenDeviceContent={this.props.isOpenDeviceContent}
//                     id={this.props.device.assetsIOTImei + 22}
//                     device={this.props.device}
//                     centerMapWihtOutFollow={this.props.centerMapWihtOutFollow}
//                     centerDevice={this.props.centerDevice}
//                     setLatLng={this.props.setLatLng}
//                     centerMap={this.props.centerMap}
//                     valueFilter={this.props.valueFilter}
//                     checkIsExpandedContentDevice={this.props.checkIsExpandedContentDevice}
//                     expandedDevice={this.props.expandedDevice}
//                 /> */}
//             </div>

//         )
//     }
// }

// export default PopUpDeviceInfo

import React, { Component } from 'react';
// import { Polyline } from '@react-google-maps/api';
import Geocode from "react-geocode";
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import HistoricalDevices from '../layerInfo/layers-devices/Historical-devices';
import HisToricalDevicesStop from '../layerInfo/layers-devices/Historical-devices-stop';
import ExploreIcon from '@material-ui/icons/Explore';
import { withTranslation } from 'react-i18next';
import config from '../../../config';

var PopUpDeviceInfo = function (_Component) {
    _inherits(PopUpDeviceInfo, _Component);

    function PopUpDeviceInfo(props) {
        var _this2 = this;

        _classCallCheck(this, PopUpDeviceInfo);

        var _this = _possibleConstructorReturn(this, (PopUpDeviceInfo.__proto__ || Object.getPrototypeOf(PopUpDeviceInfo)).call(this, props));

        _this.getHistoricalToday = function (mode) {
            _this.setState({
                popUpHistoricalTodayYesterday: false,
                popUpHistorical: false,
                mode: mode
            }, function () {
                return _this.getHistorical();
            });
        };

        _this.getHistorical = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var jsonHistoricalData, id, resposeHistoricalData, jsonListHistoricalData, resposeListHistoricalData, str, i, date, start, hours, seconds, hoursAndMinutes, duration, styleClass, maxDuration, _hours, totalMinutes, minutes, _duration, _styleClass, _maxDuration;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // console.log("getHistorical")
                            if (document.getElementById("contentPopUpDevice") !== null) {
                                document.getElementById("contentPopUpDevice").style.filter = "blur(3px)";
                            }

                            if (document.getElementById("popUpHistoricalDevice") !== null) {

                                document.getElementById("popUpHistoricalDevice").style.filter = "blur(3px)";
                                document.getElementById("spinnerLoadingPopUp").style.marginTop = "25%";
                            }

                            document.getElementById("spinnerLoadingPopUp").style.display = "block";

                            jsonHistoricalData = "";
                            id = _this.props.device.assetsInfoId !== undefined ? _this.props.device.assetsInfoId : _this.props.device.id;
                            _context.next = 7;
                            return fetch(_this.props.urlApi + "HistoricalData/SummaryTrip?VehicleId=" + id + "&mode=" + _this.state.mode, {
                                headers: {
                                    'accessToken': _this.props.accessToken
                                }
                            });

                        case 7:
                            resposeHistoricalData = _context.sent;

                            if (!resposeHistoricalData.ok) {
                                _context.next = 14;
                                break;
                            }

                            _context.next = 11;
                            return resposeHistoricalData.json();

                        case 11:
                            jsonHistoricalData = _context.sent;
                            _context.next = 15;
                            break;

                        case 14:
                            alert("HTTP-Error: " + resposeHistoricalData.status);

                        case 15:
                            jsonListHistoricalData = "";
                            _context.next = 18;
                            return fetch(_this.props.urlApi + "HistoricalData/StopsTrip?VehicleId=" + id + "&mode=" + _this.state.mode, {
                                headers: {
                                    'accessToken': _this.props.accessToken
                                }
                            });

                        case 18:
                            resposeListHistoricalData = _context.sent;

                            if (!resposeListHistoricalData.ok) {
                                _context.next = 25;
                                break;
                            }

                            _context.next = 22;
                            return resposeListHistoricalData.json();

                        case 22:
                            jsonListHistoricalData = _context.sent;
                            _context.next = 26;
                            break;

                        case 25:
                            alert("HTTP-Error: " + resposeListHistoricalData.status);

                        case 26:
                            str = jsonHistoricalData.distanceTravelled.toString();

                            str = str.replace(".", ",");
                            jsonHistoricalData.distanceTravelled = str;

                            for (i = 0; i < jsonListHistoricalData.length; i++) {

                                if (jsonListHistoricalData[i].stopTime === 0) {
                                    date = new Date();
                                    start = _this.calcDuration(jsonListHistoricalData[i].startTime);
                                    hours = Math.abs(date.getTime() - start.getTime()) / 36e5; // 36e5 => scientific notation for 60*60*1000;
                                    // console.log(hours);

                                    hours = hours.toString();

                                    seconds = (date.getTime() - start.getTime()) / 1000;
                                    hoursAndMinutes = _this.toHoursAndMinutes(seconds);

                                    // var diff = date.valueOf() - start.valueOf();
                                    // var hours = (diff / 1000 / 60 / 60); // Convert milliseconds to hours
                                    // hours = hours.toString();
                                    // console.log({ hours });

                                    // let test = new Date(hours);
                                    // console.log(test);

                                    duration = hours.split(".");

                                    //duration[1] = (duration[1] * 60)

                                    duration[1] = duration[1].toString().substr(0, 2);
                                    // .toString().substr(0,2);

                                    styleClass = "";


                                    if (duration[0] >= 8) {
                                        styleClass = "numberGreen";
                                    } else if (duration[0] <= 8 && duration[1] >= 45) {
                                        styleClass = "numberRed";
                                    } else {
                                        styleClass = "numberGray";
                                    }

                                    if (duration[0] < 10) {
                                        duration[0] = "0" + duration[0];
                                    }

                                    maxDuration = [duration[0] + ":" + duration[1], styleClass];

                                    jsonListHistoricalData[i] = {
                                        address: jsonListHistoricalData[i].address,
                                        latitude: jsonListHistoricalData[i].latitude,
                                        longitude: jsonListHistoricalData[i].longitude,
                                        startTime: _this.transformDate(jsonListHistoricalData[i].startTime),
                                        stopTime: 0,
                                        duration: hoursAndMinutes.h + ":" + hoursAndMinutes.m,
                                        styleClass: maxDuration[1],
                                        vehicleId: jsonListHistoricalData[i].vehicleId
                                    };
                                } else {
                                    _hours = (_this.calcDuration(jsonListHistoricalData[i].stopTime) - _this.calcDuration(jsonListHistoricalData[i].startTime)) / 36e5;
                                    totalMinutes = _hours * 60;

                                    _hours = _hours.toString().split(".");

                                    minutes = totalMinutes - parseInt(_hours[0]) * 60;

                                    minutes = minutes.toString().split(".");
                                    // hours = hours.toString();

                                    _duration = [_hours[0], minutes[0]];
                                    _styleClass = "";


                                    if (_duration[0] >= 8) {
                                        _styleClass = "numberGreen";
                                    } else if (_duration[0] <= 8 && _duration[1] >= 45) {
                                        _styleClass = "numberRed";
                                    } else {
                                        _styleClass = "numberGray";
                                    }

                                    if (_duration[0] < 10) {
                                        _duration[0] = "0" + _duration[0];
                                    }
                                    if (_duration[1] < 10) {
                                        _duration[1] = "0" + _duration[1];
                                    }

                                    _maxDuration = [_duration[0] + ":" + _duration[1], _styleClass];
                                    // let maxDuration = this.msToTime(diffMilliseconds);

                                    jsonListHistoricalData[i] = {
                                        address: jsonListHistoricalData[i].address,
                                        latitude: jsonListHistoricalData[i].latitude,
                                        longitude: jsonListHistoricalData[i].longitude,
                                        startTime: _this.transformDate(jsonListHistoricalData[i].startTime),
                                        stopTime: _this.transformDate(jsonListHistoricalData[i].stopTime),
                                        duration: _maxDuration[0],
                                        styleClass: _maxDuration[1],
                                        vehicleId: jsonListHistoricalData[i].vehicleId,
                                        historical: _this.props.historicalInfoDevice
                                    };
                                }
                            }

                            // let paths = [];

                            // for (let i = 0; i < jsonListHistoricalData.length; i++) {
                            //     paths.push({lat: jsonListHistoricalData[i].latitude, lng: jsonListHistoricalData[i].longitude})
                            // }
                            // console.log(paths);

                            _this.setState({
                                historicalData: jsonHistoricalData,
                                listHistoricalData: jsonListHistoricalData,
                                historical: true,
                                actualHistorical: false,
                                address: _this.props.address
                                // optionsPolyline: {...this.state.optionsPolyline, path: paths}
                            }, function () {
                                if (document.getElementById("popUpHistoricalDevice") !== null) {
                                    document.getElementById("popUpHistoricalDevice").style.removeProperty("filter");
                                }
                                document.getElementById("contentPopUpDevice").style.removeProperty("filter");
                                document.getElementById("spinnerLoadingPopUp").style.marginTop = "50%";
                                document.getElementById("spinnerLoadingPopUp").style.display = "none";

                                _this.props.HistoricalInfoDeviceOpen();
                            });

                        case 31:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.showPopUpHistoricalOptions = function () {
            document.addEventListener('mousedown', _this.handleClickOutside);
            _this.setState({
                popUpHistorical: !_this.state.popUpHistorical
            });
        };

        _this.showPopUpHistoricalOptionsTodayYesterday = function () {
            document.addEventListener('mousedown', _this.handleClickOutside);
            _this.setState({
                popUpHistoricalTodayYesterday: !_this.state.popUpHistoricalTodayYesterday
            });
        };

        _this.calcDuration = function (ticks) {
            var epochTicks = 621355968000000000;

            // console.log(ticks)
            // console.log(epochTicks)
            var ticksPerMillisecond = 10000;
            var ticksSinceEpoch = ticks - epochTicks;

            var millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;

            // console.log(millisecondsSinceEpoch);

            var date = new Date(millisecondsSinceEpoch);
            // console.log(date);
            return date;
        };

        _this.transformDate = function (ticks) {

            var epochTicks = 621355968000000000;
            var ticksPerMillisecond = 10000; // whoa!
            var maxDateMilliseconds = 8640000000000000; // via http://ecma-international.org/ecma-262/5.1/#sec-15.9.1.1
            var congratulationsTimer;

            var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

            if (isNaN(ticks)) {
                //      0001-01-01T00:00:00.000Z
                return "NANA-NA-NATNA:NA:BA.TMAN";
            }

            // convert the ticks into something javascript understands
            var ticksSinceEpoch = ticks - epochTicks;
            var millisecondsSinceEpoch = ticksSinceEpoch / ticksPerMillisecond;

            if (millisecondsSinceEpoch > maxDateMilliseconds) {
                //      +035210-09-17T07:18:31.111Z
                return "+WHOAWH-OA-ISTOO:FA:RA.WAYZ";
            }
            var date = new Date(millisecondsSinceEpoch);
            var day = date.getDate();
            if (day < 10) {
                day = "0" + day;
            }

            var month = date.getMonth();
            month = months[month];
            if (month < 10) {
                month = "0" + month;
            }

            var year = date.getFullYear();

            var hours = date.getUTCHours();

            var minutes = date.getUTCMinutes();

            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (hours < 10) {
                hours = "0" + hours;
            }

            // console.log(hours);
            var resultDate = [hours + ":" + minutes, day + "/" + month + "/" + year];
            return resultDate;
        };

        _this.handleOnClickBackHistorical = function () {
            _this.setState({
                historical: false,
                popUpHistorical: false,
                popUpInfoDevice: true,
                actualHistorical: true,
                popUpHistoricalTodayYesterday: !_this.state.popUpHistoricalTodayYesterday

            }, function () {
                return _this.props.isHistoricalInfoDeviceOpen();
            });
        };

        _this.showStopIndividually = function (dataStop, i) {

            _this.setState({
                stopDataIndividually: true,
                historical: false,
                dataStop: dataStop,
                count: i,
                popUpInfoDevice: false
            });
        };

        _this.backStopIndivudally = function () {
            _this.setState({
                stopDataIndividually: false,
                historical: true
            }, function () {
                _this.props.createMarkerHistoricalStopsIndividually();
                _this.props.HistoricalInfoDeviceOpen();
            });
        };

        _this.setWrapperRef = _this.setWrapperRef.bind(_this);
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.state = {
            stateClass: '',
            stateIconClass: '',
            label: '',
            valueFilter: '',
            address: _this.props.address,
            isOpen: true,
            isFollowDevice: false,
            historical: _this.props.historical,
            historicalData: '',
            listHistoricalData: [],
            mode: 1,
            popUpHistorical: false,
            popUpInfoDevice: true,
            actualHistorical: true,
            popUpHistoricalTodayYesterday: false,
            stopDataIndividually: false,
            dataStop: "",
            count: -1
        };
        return _this;
    }

    _createClass(PopUpDeviceInfo, [{
        key: 'getAddress',


        // componentDidMount() {
        //     this.getHistorical();
        // }

        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(lat, lng) {
                var address, response;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(lat !== 0)) {
                                    _context2.next = 14;
                                    break;
                                }

                                lat = lat.toString();
                                lng = lng.toString();

                                _context2.next = 5;
                                return fetch(config + ('maps?lat=' + lat + '&lon=' + lng));

                            case 5:
                                address = _context2.sent;

                                if (!address.ok) {
                                    _context2.next = 13;
                                    break;
                                }

                                _context2.next = 9;
                                return address.text();

                            case 9:
                                response = _context2.sent;
                                return _context2.abrupt('return', response);

                            case 13:
                                alert("HTTP-Error: " + address.status);

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getAddress(_x, _x2) {
                return _ref2.apply(this, arguments);
            }

            return getAddress;
        }()
    }, {
        key: 'calc',
        value: function calc(num) {
            var with6Decimals = num.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0];
            return with6Decimals;
        }
    }, {
        key: 'toHoursAndMinutes',
        value: function toHoursAndMinutes(totalSeconds) {
            var totalMinutes = Math.floor(totalSeconds / 60);

            //const seconds = totalSeconds % 60;
            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (hours < 10) {
                hours = "0" + hours;
            }

            return { h: hours, m: minutes };
        }
    }, {
        key: 'msToTime',
        value: function msToTime(duration) {

            var minutes = Math.floor(duration / (1000 * 60) % 60),
                hours = Math.floor(duration / (1000 * 60 * 60) % 24);

            hours = hours < 10 ? "0" + hours : hours;
            minutes = minutes < 10 ? "0" + minutes : minutes;

            var styleClass = "";

            if (hours >= 8) {
                styleClass = "numberGreen";
            } else if (hours <= 8 && minutes >= 45) {
                styleClass = "numberRed";
            } else {
                styleClass = "numberGray";
            }

            var resultArray = [hours + ":" + minutes, styleClass];
            return resultArray;
        }
    }, {
        key: 'setWrapperRef',


        /**
        * Set the wrapper ref
        */
        value: function setWrapperRef(node) {
            this.wrapperRef = node;
        }

        /**
         * Alert if clicked on outside of element
         */

    }, {
        key: 'handleClickOutside',
        value: function handleClickOutside(event) {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                this.setState({
                    popUpHistorical: false,
                    popUpHistoricalTodayYesterday: false
                });
            }
        }
    }, {
        key: 'inIframe',
        value: function inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var t = this.props.t;

            return React.createElement(
                'div',
                null,
                React.createElement('div', { id: 'spinnerLoadingPopUp', className: 'sp sp-3balls', style: { marginLeft: "50%", display: "none", marginTop: "50%" } }),
                this.state.popUpInfoDevice && this.props.device.assetsIOTInfo !== undefined ? React.createElement(
                    'div',
                    { id: 'location-detail-7', className: 'location-detail-box location-detail-7 panel panel-default' },
                    React.createElement(
                        'div',
                        { className: 'panel-body', id: 'accordion1' },
                        React.createElement(
                            'div',
                            { className: 'panel-group' },
                            this.state.popUpHistorical ? this.props.permisionHistory ? React.createElement(
                                'span',
                                { className: 'popuptext', id: 'myPopup1', ref: this.setWrapperRef },
                                React.createElement(
                                    'ul',
                                    { className: 'list-historical' },
                                    React.createElement(
                                        'li',
                                        null,
                                        t("map.sidebar.devicesContent.historicalDevices.historicalTrip")
                                    ),
                                    this.state.actualHistorical === false && React.createElement(
                                        'li',
                                        { onClick: this.handleOnClickBackHistorical.bind(this) },
                                        t("map.sidebar.devicesContent.historicalDevices.now")
                                    ),
                                    React.createElement(
                                        'li',
                                        { onClick: this.getHistoricalToday.bind(this, 0) },
                                        t("map.sidebar.devicesContent.historicalDevices.today")
                                    ),
                                    React.createElement(
                                        'li',
                                        { onClick: this.getHistoricalToday.bind(this, 1) },
                                        t("map.sidebar.devicesContent.historicalDevices.yesterday")
                                    )
                                )
                            ) : React.createElement(
                                'span',
                                { className: 'popuptext', id: 'myPopup1', ref: this.setWrapperRef },
                                React.createElement(
                                    'ul',
                                    { className: 'list-historical' },
                                    React.createElement(
                                        'li',
                                        null,
                                        t("map.sidebar.devicesContent.historicalDevices.historicalTrip")
                                    ),
                                    this.state.actualHistorical === false && React.createElement(
                                        'li',
                                        { onClick: this.handleOnClickBackHistorical.bind(this) },
                                        t("map.sidebar.devicesContent.historicalDevices.now")
                                    )
                                )
                            ) : null,
                            React.createElement(
                                'div',
                                { className: 'panel panel-default sub-group-content sub-group-1' },
                                React.createElement(
                                    'a',
                                    { 'data-toggle': 'collapse', 'data-parent': '#accordion' },
                                    React.createElement(
                                        'div',
                                        { className: 'panel-heading map-content-level2' /*onClick={this.handleOnclick.bind(this)}*/ },
                                        React.createElement(
                                            'div',
                                            { className: 'panel-title' },
                                            React.createElement(
                                                'div',
                                                { className: 'level2-heading' },
                                                React.createElement(
                                                    'div',
                                                    { className: 'level2-heading-left' },
                                                    React.createElement('span', { className: "bg-left " + this.state.stateClass }),
                                                    React.createElement('span', { className: this.state.stateIconClass }),
                                                    React.createElement(
                                                        'span',
                                                        { className: 'trackerName' },
                                                        this.props.device.assetsInfoName
                                                    )
                                                ),
                                                !this.props.origin ? React.createElement(
                                                    'div',
                                                    { className: 'level2-heading-right' },
                                                    React.createElement(
                                                        'ul',
                                                        { className: 'list-unstyled list-addons' },
                                                        React.createElement('span', { onClick: this.showPopUpHistoricalOptions.bind(this), className: 'icon-menu_circle', style: { zIndex: "1", textAlign: "center", position: "absolute", right: "60px", top: "1px", color: "#575757", cursor: "pointer", width: "30px", height: "30px" } }),
                                                        React.createElement(
                                                            'li',
                                                            null,
                                                            this.props.children
                                                        )
                                                    )
                                                ) : null
                                            )
                                        )
                                    )
                                ),
                                React.createElement('div', { className: 'clearfix' }),
                                React.createElement(
                                    'div',
                                    { className: 'collapse show' },
                                    React.createElement(
                                        'div',
                                        { className: 'panel-body level2-content', id: 'contentPopUpDevice' },
                                        React.createElement(
                                            'div',
                                            { className: 'level2-content-top' },
                                            React.createElement(
                                                'div',
                                                { className: 'level2-content-top-inner clearfix' },
                                                React.createElement(
                                                    'ul',
                                                    { className: 'level2-driver-details list-unstyled' },
                                                    React.createElement(
                                                        'li',
                                                        null,
                                                        this.props.device.assetsIOTInfo[0] !== undefined ? this.props.device.assetsIOTInfo[0].gpsInfo.timestamp : this.props.device.gpsInfo !== undefined ? this.props.device.gpsInfo.timestamp : ""
                                                    )
                                                ),
                                                React.createElement(
                                                    'ul',
                                                    { className: 'level2-driving-details list-unstyled' },
                                                    React.createElement(
                                                        'li',
                                                        null,
                                                        this.state.label
                                                    ),
                                                    React.createElement(
                                                        'li',
                                                        null,
                                                        'ID ',
                                                        this.props.device.id !== undefined ? this.props.device.id : this.props.device.assetsIOTInfo[0] !== undefined ? this.props.device.assetsIOTInfo[0].id : ""
                                                    ),
                                                    React.createElement(
                                                        'li',
                                                        null,
                                                        React.createElement(ExploreIcon, { style: { color: "#575756", marginTop: "5px", cursor: "pointer" }, onClick: this.props.device.assetsIOTInfo[0] !== undefined ? this.props.centerMap.bind(this, this.props.device.assetsIOTInfo[0].gpsInfo.latitude, this.props.device.assetsIOTInfo[0].gpsInfo.longitude, 18) : this.props.device.gpsInfo !== undefined ? this.props.centerMap.bind(this, this.props.device.gpsInfo.latitude, this.props.device.gpsInfo.longitude, 18) : null })
                                                    )
                                                )
                                            ),
                                            React.createElement(
                                                'div',
                                                { className: 'level2-content-inner' },
                                                React.createElement(
                                                    'p',
                                                    { className: 'level2-address' },
                                                    this.props.address !== undefined ? this.props.address : this.props.address
                                                ),
                                                React.createElement(
                                                    'p',
                                                    { className: 'level2-gps' },
                                                    'LAT: ',
                                                    this.props.device.assetsIOTInfo[0] !== undefined ? this.calc(this.props.device.assetsIOTInfo[0].gpsInfo.latitude) : this.props.device.gpsInfo !== undefined ? this.calc(this.props.device.gpsInfo.latitude) : null,
                                                    ' ',
                                                    React.createElement('br', null),
                                                    'LONG: ',
                                                    this.props.device.assetsIOTInfo[0] !== undefined ? this.calc(this.props.device.assetsIOTInfo[0].gpsInfo.longitude) : this.props.device.gpsInfo !== undefined ? this.calc(this.props.device.gpsInfo.longitude) : null
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'div',
                                            { className: 'level2-content-middle' },
                                            React.createElement(
                                                'ul',
                                                { className: 'list-unstyled', style: { alignItems: "center", paddingLeft: "20px", paddingRight: "20px" } },
                                                React.createElement(
                                                    'li',
                                                    null,
                                                    React.createElement('span', { className: 'icon-gauge' }),
                                                    React.createElement(
                                                        'span',
                                                        null,
                                                        this.props.device.assetsIOTInfo[0] !== undefined ? this.props.device.assetsIOTInfo[0].gpsInfo.speed : this.props.device.gpsInfo !== undefined ? this.props.device.gpsInfo.speed : null,
                                                        ' km/h'
                                                    )
                                                ),
                                                React.createElement(
                                                    FormGroup,
                                                    { 'aria-label': 'position', style: { fontSize: "10px", marginRight: "10px" }, row: true },
                                                    React.createElement(FormControlLabel, {
                                                        value: 'start',
                                                        control: React.createElement(Switch, { checked: this.props.device.assetsIOTInfo[0] !== undefined ? this.props.centerDevice.assetsIOTImei === this.props.device.assetsIOTInfo[0].assetsIOTImei && this.props.isOpenDeviceContent ? true : false : this.props.centerDevice === this.props.device.assetsIOTImei && this.props.isOpenDeviceContent ? true : false, onClick: this.props.device.assetsIOTInfo[0] !== undefined ? this.props.setLatLng.bind(this, this.props.device.assetsIOTInfo[0].gpsInfo.latitude, this.props.device.assetsIOTInfo[0].gpsInfo.longitude, this.props.device.assetsIOTInfo[0].assetsIOTImei) : this.props.device.gpsInfo !== undefined ? this.props.setLatLng.bind(this, this.props.device.gpsInfo.latitude, this.props.device.gpsInfo.longitude, this.props.device.assetsIOTImei) : null, inputProps: { 'aria-label': 'secondary checkbox' } }),
                                                        label: t("map.sidebar.devicesContent.tracking"),
                                                        labelPlacement: 'start'
                                                    })
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ) : this.state.popUpInfoDevice && this.props.device.gpsInfo !== undefined ? React.createElement(
                    'div',
                    { id: 'location-detail-7', className: 'location-detail-box location-detail-7 panel panel-default' },
                    React.createElement(
                        'div',
                        { className: 'panel-body', id: 'accordion1' },
                        React.createElement(
                            'div',
                            { className: 'panel-group' },
                            this.state.popUpHistorical ? React.createElement(
                                'span',
                                { className: 'popuptext', id: 'myPopup1', ref: this.setWrapperRef },
                                React.createElement(
                                    'ul',
                                    { className: 'list-historical' },
                                    React.createElement(
                                        'li',
                                        null,
                                        t("map.sidebar.devicesContent.historicalDevices.historicalTrip")
                                    ),
                                    this.state.actualHistorical === false && React.createElement(
                                        'li',
                                        { onClick: this.handleOnClickBackHistorical.bind(this) },
                                        t("map.sidebar.devicesContent.historicalDevices.now")
                                    ),
                                    React.createElement(
                                        'li',
                                        { onClick: this.getHistoricalToday.bind(this, 0) },
                                        t("map.sidebar.devicesContent.historicalDevices.today")
                                    ),
                                    React.createElement(
                                        'li',
                                        { onClick: this.getHistoricalToday.bind(this, 1) },
                                        t("map.sidebar.devicesContent.historicalDevices.yesterday")
                                    )
                                )
                            ) : null,
                            React.createElement(
                                'div',
                                { className: 'panel panel-default sub-group-content sub-group-1' },
                                React.createElement(
                                    'a',
                                    { 'data-toggle': 'collapse', 'data-parent': '#accordion' },
                                    React.createElement(
                                        'div',
                                        { className: 'panel-heading map-content-level2' /*onClick={this.handleOnclick.bind(this)}*/ },
                                        React.createElement(
                                            'div',
                                            { className: 'panel-title' },
                                            React.createElement(
                                                'div',
                                                { className: 'level2-heading' },
                                                React.createElement(
                                                    'div',
                                                    { className: 'level2-heading-left' },
                                                    React.createElement('span', { className: "bg-left " + this.state.stateClass }),
                                                    React.createElement('span', { className: this.state.stateIconClass }),
                                                    React.createElement(
                                                        'span',
                                                        { className: 'trackerName' },
                                                        this.props.device.assetsInfoName
                                                    )
                                                ),
                                                React.createElement(
                                                    'div',
                                                    { className: 'level2-heading-right' },
                                                    React.createElement(
                                                        'ul',
                                                        { className: 'list-unstyled list-addons' },
                                                        !this.props.origin ? React.createElement('span', { onClick: this.showPopUpHistoricalOptions.bind(this), className: 'icon-menu_circle', style: { zIndex: "1", textAlign: "center", position: "absolute", right: "60px", top: "1px", color: "#575757", cursor: "pointer", width: "30px", height: "30px" } }) : null,
                                                        React.createElement(
                                                            'li',
                                                            null,
                                                            this.props.children
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                React.createElement('div', { className: 'clearfix' }),
                                React.createElement(
                                    'div',
                                    { className: 'collapse show' },
                                    React.createElement(
                                        'div',
                                        { className: 'panel-body level2-content', id: 'contentPopUpDevice' },
                                        React.createElement(
                                            'div',
                                            { className: 'level2-content-top' },
                                            React.createElement(
                                                'div',
                                                { className: 'level2-content-top-inner clearfix' },
                                                React.createElement(
                                                    'ul',
                                                    { className: 'level2-driver-details list-unstyled' },
                                                    React.createElement(
                                                        'li',
                                                        null,
                                                        this.props.device.gpsInfo.timestamp
                                                    )
                                                ),
                                                React.createElement(
                                                    'ul',
                                                    { className: 'level2-driving-details list-unstyled' },
                                                    React.createElement(
                                                        'li',
                                                        null,
                                                        this.state.label
                                                    ),
                                                    React.createElement(
                                                        'li',
                                                        null,
                                                        'ID ',
                                                        this.props.device.id
                                                    ),
                                                    React.createElement(
                                                        'li',
                                                        null,
                                                        React.createElement(ExploreIcon, { style: { color: "#575756", marginTop: "5px", cursor: "pointer" }, onClick: this.props.centerMap.bind(this, this.props.device.gpsInfo.latitude, this.props.device.gpsInfo.longitude, 18) })
                                                    )
                                                )
                                            ),
                                            React.createElement(
                                                'div',
                                                { className: 'level2-content-inner' },
                                                React.createElement(
                                                    'p',
                                                    { className: 'level2-address' },
                                                    this.props.address !== undefined ? this.props.address : this.props.address
                                                ),
                                                React.createElement(
                                                    'p',
                                                    { className: 'level2-gps' },
                                                    'LAT: ',
                                                    this.calc(this.props.device.gpsInfo.latitude),
                                                    ' ',
                                                    React.createElement('br', null),
                                                    'LONG: ',
                                                    this.calc(this.props.device.gpsInfo.longitude)
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'div',
                                            { className: 'level2-content-middle' },
                                            React.createElement(
                                                'ul',
                                                { className: 'list-unstyled', style: { alignItems: "center", paddingLeft: "20px", paddingRight: "20px" } },
                                                React.createElement(
                                                    'li',
                                                    null,
                                                    React.createElement('span', { className: 'icon-gauge' }),
                                                    React.createElement(
                                                        'span',
                                                        null,
                                                        this.props.device.gpsInfo.speed,
                                                        ' km/h'
                                                    )
                                                ),
                                                React.createElement(
                                                    FormGroup,
                                                    { 'aria-label': 'position', style: { fontSize: "10px", marginRight: "10px" }, row: true },
                                                    React.createElement(FormControlLabel, {
                                                        value: 'start',
                                                        control: React.createElement(Switch, { checked: this.props.centerDevice.assetsIOTImei === this.props.device.assetsIOTImei && this.props.isOpenDeviceContent ? true : false,
                                                            onClick: this.props.setLatLng.bind(this, this.props.device.gpsInfo.latitude, this.props.device.gpsInfo.longitude, this.props.device.assetsIOTImei), inputProps: { 'aria-label': 'secondary checkbox' } }),
                                                        label: t("map.sidebar.devicesContent.tracking"),
                                                        labelPlacement: 'start'
                                                    })
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ) : null,
                this.state.historical ? React.createElement(
                    'div',
                    { className: 'map-content-collapsible' },
                    React.createElement(
                        HistoricalDevices,
                        {
                            transformDateAndCompare: this.props.transformDateAndCompare,
                            createMarkerHistoricalStopsIndividually: this.props.createMarkerHistoricalStopsIndividually,
                            showStopIndividually: this.showStopIndividually,
                            isHistoricalInfoDeviceOpen: this.props.isHistoricalInfoDeviceOpen
                            // historicalData={this.state.historicalData}
                            // listHistoricalData={this.state.listHistoricalData}
                            // mode={this.state.mode}
                            // urlApi={this.props.urlApi}
                            // accessToken={this.props.accessToken}
                            // checkIsExpandedContentDevice={this.checkIsExpandedContentDevice}
                            // expandedDevice={this.state.expandedDevice}
                            // id={this.props.device.assetsIOTImei + 22}
                            // address={this.state.address}
                            // isOpenDeviceContent={this.props.isOpenDeviceContent}
                            , centerMapWihtOutFollow: this.props.centerMapWihtOutFollow
                            // centerDevice={this.props.centerDevice}
                            // setLatLng={this.props.setLatLng}
                            , centerMap: this.props.centerMap
                            // valueFilter={this.props.valueFilter}
                            , device: this.props.device,
                            historicalData: this.state.historicalData,
                            listHistoricalData: this.state.listHistoricalData
                            // label={this.state.label}
                            // styleClass={this.state.class1}
                        },
                        React.createElement('span', { onClick: this.props.closePopUpDeviceInfoWithCloseIcon.bind(this), style: { zIndex: "1", textAlign: "center", position: "absolute", right: "27px", top: "2px", color: "#575757", cursor: "pointer", width: "30px", height: "30px" }, className: 'icon-close_red' }),
                        React.createElement('span', { onClick: this.showPopUpHistoricalOptionsTodayYesterday.bind(this), className: 'icon-menu_circle', style: { zIndex: "1", textAlign: "center", position: "absolute", right: "60px", top: "2px", color: "#575757", cursor: "pointer", width: "30px", height: "30px" } }),
                        this.state.popUpHistoricalTodayYesterday ? React.createElement(
                            'span',
                            { className: 'popuptext', id: 'myPopup', ref: this.setWrapperRef },
                            React.createElement(
                                'ul',
                                { className: 'list-historical' },
                                React.createElement(
                                    'li',
                                    null,
                                    t("map.sidebar.devicesContent.historicalDevices.historicalTrip")
                                ),
                                this.state.actualHistorical === false && React.createElement(
                                    'li',
                                    { onClick: this.handleOnClickBackHistorical.bind(this) },
                                    t("map.sidebar.devicesContent.historicalDevices.now")
                                ),
                                React.createElement(
                                    'li',
                                    { onClick: this.getHistoricalToday.bind(this, 0) },
                                    t("map.sidebar.devicesContent.historicalDevices.today")
                                ),
                                React.createElement(
                                    'li',
                                    { onClick: this.getHistoricalToday.bind(this, 1) },
                                    t("map.sidebar.devicesContent.historicalDevices.yesterday")
                                )
                            )
                        ) : null
                    )
                ) : null,
                this.state.stopDataIndividually ? React.createElement(
                    'div',
                    { className: 'map-content-collapsible' },
                    React.createElement(
                        HisToricalDevicesStop,
                        {
                            transformDateAndCompare: this.props.transformDateAndCompare,
                            historicalData: this.state.historicalData,
                            listHistoricalData: this.state.listHistoricalData,
                            mode: this.state.mode,
                            urlApi: this.props.urlApi,
                            accessToken: this.props.accessToken,
                            checkIsExpandedContentDevice: this.checkIsExpandedContentDevice,
                            expandedDevice: this.state.expandedDevice,
                            id: this.props.device.assetsIOTImei + 22,
                            address: this.state.address,
                            isOpenDeviceContent: this.props.isOpenDeviceContent,
                            centerMapWihtOutFollow: this.props.centerMapWihtOutFollow,
                            centerDevice: this.props.centerDevice,
                            setLatLng: this.props.setLatLng,
                            centerMap: this.props.centerMap,
                            valueFilter: this.props.valueFilter,
                            device: this.props.device,
                            label: this.state.label,
                            styleClass: this.state.class1,
                            dataStop: this.state.dataStop,
                            count: this.state.count

                        },
                        React.createElement(
                            'div',
                            { onClick: this.backStopIndivudally },
                            React.createElement('span', { /*onClick={this.backStopIndividually.bind(this)}*/className: 'icon-colapse_down', style: { rotate: "90deg", zIndex: "1", textAlign: "center", position: "absolute", right: "60px", top: "2px", color: "#575757", cursor: "pointer", width: "30px", height: "30px" } }),
                            React.createElement(
                                'span',
                                { style: { zIndex: "1", textAlign: "center", position: "absolute", right: "25px", top: "9px", color: "#575757", cursor: "pointer", width: "30px", height: "30px" } },
                                'Atr\xE1s'
                            )
                        )
                    )
                )

                // <div id="trip-view-detail-content">
                //     <div id="trip-view-detail">

                //         <ul className="list-unstyled">
                //             {/* <li><span className="icon-time"></span><span>00:44 h</span></li>
                //                 <li><span className="icon-gauge"></span><span>26 km/h</span></li> */}

                //             <li><span style={{ rotate: "90deg" }} onClick={this.backStopIndividually} className="icon-colapse_down"></span><span>back</span></li>
                //         </ul>
                //         <div class="trip-view-bottom">
                //             <span class="trip-detail-number">2</span>
                //             <span class="trip-detail-time">Wednesday 9/12/2018</span>
                //             <span class="trip-detail-duration"><span
                //                 class="icon-chrono"></span><span>00:35<span>h</span></span></span>
                //         </div>
                //         <div className="trip-view-detail-content-bottom clearfix">

                //             <div className="detail-content-bottom-heading">
                //                 <h5>PREVIOUS</h5>
                //             </div>
                //             <div className="detail-content-bottom-inner clearfix">
                //                 <div className="detail-content-bottom-inner-left">
                //                     <span>09-12-2018</span><br />
                //                     <span>08:15:54 <span>h</span></span>
                //                 </div>
                //                 <div className="detail-content-bottom-inner-right">
                //                     Ctra. Villaverde a Vallecas, 267B, 28031 Madrid, Espana
                //                 </div>
                //             </div>

                //         </div>
                //         <div className="trip-view-detail-content-bottom clearfix">
                //             <div className="detail-content-bottom-heading">
                //                 <h5>STOP POINT</h5>
                //             </div>
                //             <div className="detail-content-bottom-inner clearfix">
                //                 <div className="detail-content-bottom-inner-left">
                //                     <span>09-12-2018</span><br />
                //                     <span>09:00:27 <span>h</span></span>
                //                 </div>
                //                 <div className="detail-content-bottom-inner-right">
                //                     Av Pintor Felo Monzon, 37, 328031 Madrid, Espana
                //                 </div>
                //             </div>

                //         </div>
                //     </div>


                // </div>
                : null
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, state) {
            var _ref3 = '',
                stateClass = _ref3.stateClass,
                stateIconClass = _ref3.stateIconClass,
                label = _ref3.label,
                historical = _ref3.historical;
            var t = props.t;

            historical = props.historicalInfoDevice;
            if (props.device !== undefined) {

                if (props.device.assetsIOTInfo !== undefined) {
                    if (props.device.assetsIOTInfo[0].tipoTrama === "ONM") {
                        stateClass = 'map-green-bg';
                        stateIconClass = 'icon-road2';
                        label = t("map.sidebar.filtersDevices.driving");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFM") {
                        stateClass = 'map-green-bg';
                        stateIconClass = 'icon-road2';
                        label = t("map.sidebar.filtersDevices.driving");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "ONS") {
                        stateClass = 'map-yellow-bg';
                        stateIconClass = 'icon-stop_sign';
                        label = t("map.sidebar.filtersDevices.stop");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFS") {
                        stateClass = 'map-red-bg';
                        stateIconClass = 'icon-parking';
                        label = t("map.sidebar.filtersDevices.parked");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFGPRS") {
                        stateClass = 'map-blue-bg';
                        stateIconClass = 'icon-no_gprs';
                        label = t("map.sidebar.filtersDevices.noGprs");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFGPS") {
                        stateClass = 'map-violet-bg';
                        stateIconClass = 'icon-no_gps';
                        label = "No GPS";
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFINS") {

                        stateClass = 'map-black-bg';
                        stateIconClass = 'icon-radar';
                        label = "Pendiente de instalación";
                    }
                    // let noGprs = props.transformDateAndCompare(props.device.assetsIOTInfo[0].gpsInfo.timestampApi);
                    // if (noGprs) {
                    //     stateClass = 'map-blue-bg';
                    //     stateIconClass = 'icon-no_gprs';
                    //     label = t("map.sidebar.filtersDevices.noGprs");
                    // }
                } else {
                    if (props.device.tipoTrama !== undefined) {
                        if (props.device.tipoTrama === "ONM") {
                            stateClass = 'map-green-bg';
                            stateIconClass = 'icon-road2';
                            label = t("map.sidebar.filtersDevices.driving");
                        }
                        if (props.device.tipoTrama === "OFM") {
                            stateClass = 'map-green-bg';
                            stateIconClass = 'icon-road2';
                            label = t("map.sidebar.filtersDevices.driving");
                        }
                        if (props.device.tipoTrama === "ONS") {
                            stateClass = 'map-yellow-bg';
                            stateIconClass = 'icon-stop_sign';
                            label = t("map.sidebar.filtersDevices.stop");
                        }
                        if (props.device.tipoTrama === "OFS") {
                            stateClass = 'map-red-bg';
                            stateIconClass = 'icon-parking';
                            label = t("map.sidebar.filtersDevices.parked");
                        }
                        if (props.device.tipoTrama === "OFGPRS") {
                            stateClass = 'map-blue-bg';
                            stateIconClass = 'icon-no_gprs';
                            label = t("map.sidebar.filtersDevices.noGprs");
                        }
                        if (props.device.tipoTrama === "OFGPS") {
                            stateClass = 'map-violet-bg';
                            stateIconClass = 'icon-no_gps';
                            label = "No GPS";
                        }
                        if (props.device.tipoTrama === "OFINS") {

                            stateClass = 'map-black-bg';
                            stateIconClass = 'icon-radar';
                            label = "Pendiente de instalación";
                        }
                        // let noGprs = props.transformDateAndCompare(props.device.gpsInfo.timestampApi);
                        // if (noGprs) {
                        //     stateClass = 'map-blue-bg';
                        //     stateIconClass = 'icon-no_gprs';
                        //     label = t("map.sidebar.filtersDevices.noGprs");
                        // }
                    }
                }

                return {
                    stateClass: stateClass,
                    stateIconClass: stateIconClass,
                    label: label,
                    historical: historical,
                    actualHistorical: !historical
                };
            }
        }
    }]);

    return PopUpDeviceInfo;
}(Component);

export default withTranslation()(PopUpDeviceInfo);